const getNetEffectPointEstimate = (compositionResourceState) => {
    if (compositionResourceState?.section) {
        for (const section of compositionResourceState.section) {
            if (section.code?.text === 'Net Effect Point Estimate') {
                if (section.text?.div) {
                    return section.text.div;
                }
            }
        }
    }
};

export default getNetEffectPointEstimate;